<template>
    <div class="app-container">
        <div class="faq-container">
            <div class="Policy"><h1>นโยบายการดำเนินงาน
</h1>
<p>[นโยบายการทำงานของเกม]
</p>
<p>
</p>
<p>หนึ่ง หลักการทั่วไป
</p>
<p>(1) นโยบายการดำเนินงานนี้ ("นโยบายการดำเนินงานต่อไปนี้") เกี่ยวข้องกับบริการเกมบนมือถือที่จัดหาให้โดย PANGSKY ("บริษัท") และบริการต่างๆ ที่ให้บริการโดยแพลตฟอร์มรวมของบริษัท ("บริการ") บริษัท และ ตามเงื่อนไขการใช้บริการเกมและข้อกำหนดการใช้บริการ (ต่อไปนี้เรียกว่า "ข้อกำหนดการใช้งาน") สมาชิกจะรักษาความสอดคล้องในปัญหาและเงื่อนไขต่าง ๆ ที่เกิดขึ้นระหว่างการปฏิบัติตามสัญญาเพื่อรักษาลำดับบริการ
</p>
<p>(2) เพื่อให้บริการที่ราบรื่น บริษัทสามารถปรับเปลี่ยน "นโยบายการดำเนินงาน" ภายในขอบเขตที่ไม่ละเมิดกฎหมายและระเบียบข้อบังคับที่เกี่ยวข้อง เมื่อบริษัทเปลี่ยนแปลงนโยบายการดำเนินงาน บริษัทจะเปลี่ยนเนื้อหาของการดำเนินงานโดยชัดแจ้ง กรมธรรม์และวันใช้บังคับเริ่มตั้งแต่วันที่สมัคร7 ประกาศให้สมาชิกทราบในรูปแบบประกาศภายในบริการหรือในชุมชนเมื่อไม่กี่วันก่อน อย่างไรก็ตาม หากมีการแก้ไขเนื้อหาที่ไม่เป็นประโยชน์ต่อสมาชิก ให้ประกาศในลักษณะเดียวกัน 30 วันก่อนวันที่มีผลบังคับใช้
</p>
<p>(3) สำหรับเรื่องที่ไม่ได้กำหนดไว้ในการตีความนโยบายการดำเนินงานและนโยบายการดำเนินงาน ให้ปฏิบัติตาม "ข้อกำหนดการใช้งาน" และสำหรับเรื่องอื่นๆ ให้ปฏิบัติตามกฎหมายและข้อบังคับที่เกี่ยวข้องและข้อบังคับที่เกี่ยวข้อง
</p>
<p>(4) แม้ว่าจะมีการประกาศเปลี่ยนแปลงนโยบายการดำเนินงานแล้ว แต่ก็เป็นการยากที่จะช่วยให้เกิดความสูญเสียที่เกิดขึ้นโดยไม่รู้ตัว โปรดตรวจสอบประกาศได้ตลอดเวลา
</p>
<p>
</p>
<p>2. คำจำกัดความของคำศัพท์
</p>
<p>ข้อกำหนดที่ใช้ในนโยบายการดำเนินงานมีการกำหนดดังนี้:
</p>
<p>(1) ทีมปฏิบัติการ (หรือ GM)" หมายถึง บุคคลที่รับผิดชอบในบริษัทหรือบุคคลที่ได้รับอนุญาตจากบริษัทที่มีบทบาทในการช่วยให้สมาชิกใช้บริการได้อย่างราบรื่น
</p>
<p>(2) "สมาชิก" หมายถึง บุคคลที่ลงนามในสัญญาการใช้งานของบริษัทและใช้บริการ
</p>
<p>(3) ชื่อ" หมายถึงชื่อทั้งหมดที่กำหนดโดยสมาชิก เช่น ชื่อผู้ใช้และชื่อบทบาท
</p>
<p>(4) ข้อมูลบัญชี" หมายถึง หมายเลขบัญชีและรหัสผ่านที่สมาชิกกำหนดเพื่อใช้บริการ ตลอดจนข้อมูลที่บริษัทกำหนดโดยพลการ
</p>
<p>(5) ข้อมูลเกม" หมายถึงอุปกรณ์เกม เหรียญในเกม คะแนน ประสิทธิภาพ และข้อมูลอื่น ๆ ที่เกี่ยวข้องกับการเล่นเกมที่สมาชิกได้รับในกระบวนการใช้บริการ
</p>
<p>(6) "พฤติกรรมที่ไม่เหมาะสมและผิดปกติ" หมายถึง การฉ้อฉล การทำธุรกรรมเงินสด ข้อบกพร่องและการใช้ระบบในทางที่ผิด การใช้โปรแกรมที่ผิดกฎหมาย การแอบอ้างบุคคลอื่น การฉ้อโกง การใช้ในทางที่ผิด การขโมย การขัดขวางเกม การละเมิดชีวิตส่วนตัว การขัดขวาง การดำเนินการบริการ พฤติกรรมที่ก่อให้เกิดอันตรายและความรังเกียจต่อสมาชิกคนอื่น ๆ พฤติกรรมที่โดยทั่วไปไม่เป็นที่ยอมรับในสังคมและพฤติกรรมที่ไม่แข็งแรงอื่น ๆ ทั้งหมด
</p>
<p>(7) ยักยอก" หมายถึงการกระทำของการดำเนินการที่น่ารับประทานกับข้อมูลเกมของบุคคลอื่น (คุณสมบัติในเกม ตัวละคร ฯลฯ ) โดยไม่ได้รับความยินยอมจากบุคคลอื่นหรือการกระทำของการใช้ข้อมูลการชำระเงินของบุคคลอื่นสำหรับ การตั้งถิ่นฐานโดยไม่ได้รับความยินยอมจากบุคคลอื่น ฯลฯ การดำเนินการทั้งหมดของบัญชีของบุคคลอื่น
</p>
<p>(8) "ธุรกรรมเงินสด" หมายถึงการแนะนำข้อมูลเกม ความพยายามในการทำธุรกรรมหรือการทำธุรกรรมในรูปของเงินสดหรือในรูปแบบต่างๆ
</p>
<p>(9) การใช้ระบบจุดบกพร่องที่เป็นอันตราย" หมายถึงการใช้ลิงก์ที่อ่อนแอโดยเจตนา (จุดบกพร่อง ข้อผิดพลาดของระบบ ฯลฯ) ในบริการ
</p>
<p>(10) "โปรแกรมที่ผิดกฎหมาย" หมายถึงโปรแกรม เครื่องใช้และอุปกรณ์ที่ทำขึ้นเพื่อวัตถุประสงค์ในการขัดขวางการทำงานตามปกติของบริการ ละเมิดลิขสิทธิ์หรือแก้ไข ทำลายข้อมูลที่เกี่ยวข้อง หรือการปลอมแปลง
</p>
<p>(11) "ชื่อส่วนตัว" หมายถึง การปกปิดชื่อ ตัวตน ฯลฯ
</p>
<p>(12) การฉ้อโกง" หมายถึงการใช้ข้อมูลเท็จเพื่อสร้างความสับสนหรือหลอกลวงบุคคลที่สามหรือทำให้เกิดความสูญเสีย
</p>
<p>(13) สิ่งที่เรียกว่า "การโกง" หมายถึงการใช้เกมซ้ำๆ เป็นระยะๆ หรือไม่เป็นระยะเพื่อรับข้อมูลเฉพาะเกมจำนวนมาก (คะแนน ความสำเร็จ อุปกรณ์ประกอบฉาก เหรียญในเกม ฯลฯ) หรือช่วยเหลือพวกเขา พฤติกรรม.
</p>
<p>(15) “การล้างกำแพง” หมายถึงการเผยแพร่หรือลงทะเบียนบทความ ภาพถ่าย ฯลฯ ซ้ำๆ ในกระดานข่าวและพื้นที่อื่นๆ เพื่อแสดงความคิดเห็นหรือแสดงความไม่พอใจ
</p>
<p>(16) การแทรกแซงความคืบหน้าของเกม" หมายถึงการกระทำที่เป็นการรบกวนหรือขัดขวางการใช้บริการตามปกติเพื่อสร้างความเสียหายให้กับบุคคลที่สาม
</p>
<p>(17) การละเมิดชีวิตส่วนตัว" หมายถึงการเปิดเผยหรือใช้ข้อมูลส่วนบุคคลของบุคคลที่สามโดยประสงค์ร้าย
</p>
<p>(18) "หยุดใช้" หมายถึงการยุติบริการเกมและบริการชุมชนต่างๆ (การแจ้ง ฯลฯ)
</p>
<p>(19) "การตั้งถิ่นฐานที่ผิดปกติ" หมายถึงการใช้บัตรเครดิตของบุคคลที่สาม โทรศัพท์มือถือ ARS และวิธีการชำระเงินอื่น ๆ อย่างไม่สมเหตุสมผลเพื่อซื้อสินค้าที่เรียกเก็บเงินและบริการเกมอื่น ๆ และใช้พฤติกรรมการชำระค่าใช้จ่ายที่ไม่ได้รับอนุญาตและการตั้งถิ่นฐานหรือการตั้งถิ่นฐานใน ลักษณะที่ไม่ได้รับการอนุมัติจาก บริษัท การดำเนินการทั้งหมดถูกยกเลิก
</p>
<p>(20) การเข้าร่วมเป็นสมาชิกที่ผิดปกติ" หมายถึงการเข้าร่วมในลักษณะที่ไม่ได้รับการอนุมัติจากบริษัท เช่น การจงใจเข้าร่วมเพื่อรับไอเท็มเกม/สกุลเงินในเกม ฯลฯ อย่างไม่เหมาะสม
</p>
<p>
</p>
<p>3. ภาระผูกพันและสิทธิ์ของลูกค้า
</p>
<p>(1) สมาชิกต้องปฏิบัติตามข้อกำหนดการใช้งานและนโยบายการดำเนินงานของบริษัท สมาชิกสามารถรับผิดชอบต่อความสูญเสียและผลลัพธ์หากพวกเขาละเมิดนโยบายการดำเนินงาน
</p>
<p>(2) สมาชิกมีสิทธิ์เลือกใช้เกมและองค์ประกอบบริการทั้งหมดที่มีให้ในบริการ
</p>
<p>(3) บริษัทมีสิทธิ์ในข้อมูลทั้งหมดที่เกี่ยวข้องกับบริการของสมาชิก (ตัวละคร อุปกรณ์ประกอบฉาก เหรียญเกม ฯลฯ) และให้สิทธิ์สมาชิกในการใช้ข้อมูล
</p>
<p>(4) เมื่อสมาชิกได้รับการปฏิบัติที่ไม่เหมาะสมหรือประสบความสูญเสียเมื่อใช้บริการ เขามีสิทธิที่จะคัดค้านบริษัทและขอให้แก้ไขด้วยวิธีการและขั้นตอนที่เหมาะสม และเมื่อเขาได้รับการปฏิบัติที่ไม่เหมาะสมหรือความสูญเสียจากสมาชิกรายอื่น เขามีสิทธิรายงานต่อบริษัท แจ้งเนื้อหาและขอใช้นโยบายที่สมาชิกท่านอื่นกำหนด
</p>
<p>(5) สมาชิกสามารถปรึกษา แนะนำ และขอบริการที่เกี่ยวข้องได้ผ่านช่องทางต่อไปนี้
</p>
<p>(6) เมื่อเข้าร่วมเป็นสมาชิก สมาชิกควรกรอกข้อมูลที่จำเป็นตามความเป็นจริงตามข้อมูลส่วนบุคคลของพวกเขา เมื่อลงทะเบียนสมาชิก ป้อนข้อมูลเท็จ หรือลงทะเบียนกับข้อมูลของผู้อื่น คุณต้องไม่ได้รับมาตรการป้องกันจากบริษัท และอาจถูกกีดกันจากกิจกรรมหรือถูกจำกัดจากการใช้บริการ
</p>
<p>(7) สมาชิกต้องรักษาและปรับปรุงข้อมูลที่กรอกเพื่อรักษาข้อมูลที่กรอกไว้อย่างถูกต้อง และไม่อนุญาตให้บุคคลที่สามใช้ข้อมูลที่ให้ไว้กับบริษัท
</p>
<p>(8) สมาชิกจำเป็นต้องทำความคุ้นเคยกับข้อมูลที่ส่งอย่างเป็นทางการในบริษัทหรือบริการ และบริษัทหรือบริการจะไม่รับผิดชอบต่อความสูญเสียที่เกิดจากความไม่คุ้นเคย
</p>
<p>(9) หากไม่ได้รับความยินยอมจากบริษัท สมาชิกจะไม่ได้รับอนุญาตให้ใช้บริการเพื่อมีส่วนร่วมในกิจกรรมการแสวงหาผลกำไรใดๆ
</p>
<p>(10) หากไม่ได้รับความยินยอมจากบริษัท สมาชิกไม่สามารถใช้ข้อมูลที่ได้รับผ่านบริการโดยการคัดลอก คัดลอก แก้ไข แปล เผยแพร่ ออกอากาศ และวิธีการอื่นๆ หรือมอบให้กับผู้อื่น
</p>
<p>(11) เมื่อสมาชิกพบหรือมีบริการที่อ่อนแอ (ข้อบกพร่อง ข้อผิดพลาดของระบบ โปรแกรมที่ผิดกฎหมาย ฯลฯ) เขาต้องแจ้งให้บริษัททราบและจะไม่เผยแพร่หรือใช้โดยประสงค์ร้ายต่อสมาชิกรายอื่น หลังจากพบจุดอ่อนของบริการแล้ว หากนำไปใช้ในทางที่ผิดหรือโอนให้ผู้อื่นโดยไม่แจ้งให้บริษัททราบ อาจถูกตัดสินว่าเป็นพฤติกรรมที่ไม่เหมาะสมและผิดปกติโดยเจตนา และการใช้บริการจะถูกจำกัดตาม "นโยบาย" และจะยอมรับบทลงโทษตามกฎหมายที่เกี่ยวข้อง
</p>
<p>(12) สมาชิกควรเคารพลิขสิทธิ์ของบุคคลที่สามและสิทธิ์อื่นๆ ของผู้อื่น หากใช้ลิขสิทธิ์โดยไม่ได้รับอนุญาตจากเจ้าของลิขสิทธิ์ บริษัทจะถือเป็นการละเมิดลิขสิทธิ์ตามกฎหมายลิขสิทธิ์ฉบับปัจจุบัน ดังนั้นหากพบข้อมูลที่เกี่ยวข้องก็ควรแจ้งให้บริษัททราบเพื่อให้บริษัทได้ดำเนินการตามมาตรการที่เหมาะสม
</p>
<p>
</p>
<p>สี่ การจัดการบัญชี
</p>
<p>(1) บริษัทมุ่งมั่นที่จะปกป้องข้อมูลบัญชีของสมาชิก อย่างไรก็ตาม ความรับผิดชอบอันดับแรกสำหรับข้อมูลบัญชีเป็นของสมาชิก
</p>
<p>(2) ความรับผิดชอบสำหรับผลที่ตามมาทั้งหมดที่เกิดจากการใช้ข้อมูลส่วนบุคคลของบุคคลที่สาม เช่น ID และรหัสผ่านของสมาชิก อยู่ที่สมาชิก ความรับผิดชอบสำหรับการสูญเสียการใช้บริการที่เกิดจากการจัดการที่ประมาทเลินเล่อหรือการใช้งานที่ไม่เหมาะสมของ บุคคลภายนอกมีกำหนด สมาชิกมีหน้าที่รับผิดชอบ และบริษัทจะไม่รับผิดชอบ
</p>
<p>(3) สมาชิกไม่ได้รับอนุญาตให้ใช้หรือยักยอกข้อมูลส่วนบุคคลของบุคคลที่สาม และการยักยอกข้อมูลส่วนบุคคลของบุคคลที่สามอาจมีโทษตามกฎหมายที่เกี่ยวข้อง
</p>
<p>(4) เมื่อแบ่งปันข้อมูลบัญชีกับบุคคลที่สามหรือพยายามทำธุรกรรมเงินสด/สปอต เช่น ข้อมูลบัญชี บทบาท อุปกรณ์ประกอบฉาก ฯลฯ ไม่จำเป็นต้องเตือนล่วงหน้า และสามารถถูกลงโทษตาม นโยบายการดำเนินงานดังนั้นความรับผิดชอบทั้งหมดที่เกิดขึ้นคือสมาชิกที่ลงทะเบียนข้อมูลบัญชีแบกรับ นอกจากนี้ ธุรกรรมหรือการโอนข้อมูลบัญชี ตัวละคร รายการ ฯลฯ ไม่ได้รับการอนุมัติ
</p>
<p>
</p>
<p>V. นโยบายการตั้งชื่อ
</p>
<p>(1) โดยหลักการแล้ว คุณสามารถตั้งชื่อได้อย่างอิสระ เช่น ชื่อบทบาท ชื่อเล่น ฯลฯ ในระหว่างการใช้บริการ อย่างไรก็ตาม ในกรณีต่อไปนี้ ทีมปฏิบัติการสามารถเปลี่ยนชื่อเป็นขอบเขตอำนาจหน้าที่ได้ หากสะสมเป็นกรณีเดียวกัน อาจมีการคว่ำบาตรเพิ่มเติม
</p>
<p>- ชื่อของคำสบถ คำแสลง โฆษณา เนื้อหาลามกอนาจาร ฯลฯ ;
</p>
<p>- ชื่อของเชื้อชาติและการเลือกปฏิบัติทางเพศ;
</p>
<p>- ชื่อที่มีจุดประสงค์ในการวิจารณ์ ดูหมิ่น หรือสร้างความเสียหายแก่บุคคล กลุ่ม กลุ่ม ภูมิภาค ศาสนา ฯลฯ
</p>
<p>- ความตั้งใจที่จะปลอมแปลงเป็น บริษัท พนักงานของบริษัท บุคลากรที่เกี่ยวข้อง เจ้าหน้าที่ปฏิบัติการ ฯลฯ หรืออาจมีการระบุว่าเป็นชื่อบริษัท
</p>
<p>- รหัสที่อาจละเมิดลิขสิทธิ์ เครื่องหมายการค้า และสิทธิ์อื่นๆ ของบุคคลที่สาม
</p>
<p>- ชื่อของเนื้อหาที่ละเมิดกฎหมายที่เกี่ยวข้อง;
</p>
<p>- ภายใต้การตัดสินอย่างเป็นกลางของทีมปฏิบัติการอื่น จำเป็นต้องเปลี่ยนชื่อ
</p>
<p>
</p>
<p>VI. นโยบายการกู้คืน
</p>
<p>(1) เมื่อบริษัทสูญเสียหรือเปลี่ยนแปลงข้อมูลเกม เช่น ตัวละคร อุปกรณ์ประกอบฉาก เหรียญเกม ฯลฯ เนื่องจากการใส่ร้ายป้ายสีของบริษัทหรือข้อผิดพลาดทางเทคนิคในการให้บริการ ข้อมูลเกมจะถูกกู้คืนภายในขอบเขตของข้อมูลวัตถุประสงค์ และข้อมูลยืนยันโดยการจัดการข้อมูลด้วย
</p>
<p>(2) การสูญหายหรือเปลี่ยนแปลงข้อมูลเกมอันเนื่องมาจากความไม่คุ้นเคยกับเนื้อหาที่ระบุใน "ความประมาทเลินเล่อ ความประมาทเลินเล่อในการบริหารหรือนโยบายการดำเนินงานของสมาชิก" บริการเกมหรือเนื้อหาที่ประกาศผ่านประกาศ ฯลฯ จะไม่ จะทำการประมวลผลการกู้คืน
</p>
<p>(3) สามารถดำเนินการตรวจสอบและดำเนินการได้ภายใน 7 วันนับจากวันที่ยอมรับเท่านั้น อย่างไรก็ตาม ขึ้นอยู่กับระยะเวลาการจัดเก็บ DB ของเกมต่างๆ อาจมีผลลัพธ์ที่แตกต่างกัน
</p>
<p>(4) การสมัครขอคืนสถานะควรได้รับการยอมรับโดยตรงจากสมาชิกที่มีปัญหา และไม่ยอมรับหน่วยงานของบุคคลที่สาม
</p>
<p>(5) หากได้รับการยืนยันว่าแอปพลิเคชันการกู้คืนเป็นเท็จ การใช้บริการและมาตรการทางกฎหมายสามารถจำกัดได้ตาม "9. ใช้ระเบียบการจำกัดการใช้" ของนโยบายการดำเนินงาน
</p>
<p>(6) บริษัทไม่สนับสนุนมาตรการฟื้นฟูในกรณีต่อไปนี้ในแอปพลิเคชันการกู้คืนที่ยอมรับ:
</p>
<p>ข้อมูลบัญชีของสมาชิกเองไม่มีรายละเอียด
</p>
<p>- ความสูญเสียที่เกิดขึ้นจากการแบ่งปัน โอน หรือซื้อและขายข้อมูลบัญชีให้กับบุคคลที่สาม
</p>
<p>แจ้งเหตุเกิน 7 วัน นับแต่วันที่เกิดเหตุ
</p>
<p>- ความสูญเสียที่เกิดขึ้นเนื่องจากการไม่คุ้นเคยกับเนื้อหาที่แนะนำในนโยบายการดำเนินการ ประกาศอย่างเป็นทางการของชุมชน (ชุมชนฟอรัม) การประกาศในเกม ฯลฯ
</p>
<p>ความสูญเสียอันเนื่องมาจากบริการเกมตามปกติของสมาชิก เช่น การจำหน่ายผลิตภัณฑ์ การสังเคราะห์ การย่อยสลาย ฯลฯ
</p>
<p>- การสูญเสียที่เกิดจากการเปลี่ยนแปลงอุปกรณ์หรือการเริ่มต้นอุปกรณ์
</p>
<p>เมื่อลงทะเบียน/ขาย/ซื้อโภคภัณฑ์ในการแลกเปลี่ยน ความสูญเสียที่เกิดขึ้นเนื่องจากความล้มเหลวในการยืนยันชื่อ ราคา หมายเลข และข้อมูลการทำธุรกรรมอื่นๆ ของสินค้าโภคภัณฑ์อย่างถูกต้อง
</p>
<p>-การฉ้อโกงในเกมและความสูญเสียอื่น ๆ เนื่องจากปัญหาระหว่างสมาชิกโดยปราศจากการแทรกแซงของ บริษัท แต่เพื่อป้องกันการสูญเสียเพิ่มเติมหลังจากยืนยันข้อมูลการใช้บัญชีที่ละเมิดรายการที่เกี่ยวข้องกับการฉ้อโกงสกุลเงินของเกม ฯลฯ สามารถนำกลับมาใช้ใหม่ได้
</p>
<p>- เมื่อไม่สามารถรักษาความปลอดภัยข้อมูลวัตถุประสงค์ตามข้อมูลผู้ใช้เกมได้ เป็นการยากที่จะพิสูจน์เนื้อหาที่ชัดเจนผ่านข้อมูลการเข้าสู่ระบบและไม่สามารถกู้คืนได้เนื่องจากปรากฏการณ์ความล่าช้าตามปกติ (ปรากฏการณ์การหน่วงเวลาในเกม) และสิ่งกีดขวางทางเส้น
</p>
<p>(7) ตามการตัดสินใจของการวางแผนหรือการดำเนินงานของบริการ ข้อมูลเกมของสมาชิกสามารถแก้ไข/เปลี่ยนแปลง/ลบ และแนะนำผ่านการประกาศก่อนหน้านี้ นอกจากนี้ ในกรณีนี้ ข้อมูลเกมจะไม่สามารถกู้คืนได้
</p>
<p>(8) สินค้าที่จำหน่ายเป็นกิจกรรมการบริการและค่าตอบแทนอาจไม่สามารถซ่อมแซมได้
</p>
<p>
</p>
<p>เซเว่น หน้าที่และบทบาทของทีมปฏิบัติการ
</p>
<p>(1) ทีมปฏิบัติการมีความคุ้นเคยและปฏิบัติตามเงื่อนไขการใช้งาน นโยบายการดำเนินงาน และนโยบายการจัดการข้อมูลส่วนบุคคล
</p>
<p>(2) ผู้ให้บริการจะพยายามอย่างเต็มที่เพื่อป้องกันการละเมิดนโยบายการดำเนินงานและให้บริการที่ราบรื่น
</p>
<p>(3) ผู้ดำเนินการต้องไม่ปรึกษา แก้ไข เปิดเผย หรือแจกจ่ายข้อมูลส่วนบุคคลของสมาชิก อย่างไรก็ตาม เมื่อหน่วยงานของรัฐหรือหน่วยงานตุลาการร้องขอข้อมูลส่วนบุคคลผ่านกระบวนการทางกฎหมาย หน่วยงานดังกล่าวสามารถให้ข้อมูลส่วนบุคคลแก่หน่วยงานที่เกี่ยวข้องได้
</p>
<p>(4) ทีมปฏิบัติการยอมรับข้อมูลที่สมาชิกให้มาเกี่ยวกับจุดบกพร่องและข้อผิดพลาดทุกรูปแบบผ่านศูนย์บริการลูกค้าและเว็บไซต์ชุมชน และมีหน้าที่ยืนยันและขอให้แก้ไขอย่างรวดเร็ว
</p>
<p>(5) ยกเว้นเรื่องที่เกี่ยวกับเกมซึ่งเปิดเผยผ่านคำแนะนำและประกาศเกี่ยวกับเกม ผู้ดำเนินการไม่ได้ให้ความเห็นเกี่ยวกับวัตถุประสงค์หรือความคืบหน้าของเกมที่สมาชิกต้องบรรลุในบริการ
</p>
<p>(6) โดยหลักการแล้ว ผู้ดำเนินการจะไม่เข้าไปแทรกแซงหรือมีส่วนร่วมในกิจกรรมปกติหรือข้อพิพาทของสมาชิกภายในบริการ
</p>
<p>(7) ผู้ดำเนินการเชื่อว่าเมื่อเกิดปรากฏการณ์ผิดปกติหรือไม่ได้ตั้งใจขึ้นภายใน/ภายนอกบริการ ซึ่งส่งผลให้เกิดปัญหาการให้บริการที่ขัดขวาง อาจจำกัดบริการบางส่วนหรือทั้งหมดได้
</p>
<p>(8) เมื่อทีมปฏิบัติการเชื่อว่าพฤติกรรมของสมาชิกหรือกลุ่มเฉพาะขัดขวางการให้บริการที่ราบรื่นหรือละเมิดนโยบายการดำเนินงาน ก็สามารถใช้มาตรการต่างๆ กับการใช้บริการของสมาชิกหรือกลุ่มเฉพาะตาม " ข้อ 8 และ 9"
</p>
<p>(9) เมื่อผู้ดำเนินการเชื่อว่ามีสถานการณ์ที่ไม่ได้ระบุไว้อย่างชัดเจนใน "นโยบาย" และจำเป็นต้องดำเนินกิจกรรมเพื่อให้บริการที่ราบรื่น สามารถออกคำเตือนไปยังสมาชิกหรือกลุ่มหรือคำขอเฉพาะ และสามารถดำเนินการได้หากไม่เห็นด้วยกับคำขอ มาตรการเช่นบังคับให้ปิดระบบหรือจำกัดการใช้งาน
</p>
<p>
</p>
<p>แปด. มาตรฐานของพฤติกรรมอนาจารและผิดปกติ
</p>
<p>(1) "พฤติกรรมที่ไม่เหมาะสมและผิดปกติ" หมายถึง การฉ้อฉล การทำธุรกรรมเงินสด ข้อบกพร่องและการใช้ระบบในทางที่ผิด การใช้โปรแกรมที่ผิดกฎหมาย การแอบอ้างบุคคลอื่น การฉ้อโกง การใช้ในทางที่ผิด การขโมย การขัดขวางเกม การบุกรุกความเป็นส่วนตัว การขัดขวาง การดำเนินงานบริการ การใช้และการปฏิบัติ การกระทำที่ก่อให้เกิดความสูญเสียต่อสมาชิกคนอื่น ๆ และการกระทำทั้งหมดที่ละเมิด "พฤติกรรมที่ไม่เป็นที่ยอมรับในแนวคิดทางสังคมแบบดั้งเดิม" และกฎหมายและข้อบังคับอื่น ๆ ที่เกี่ยวข้อง
</p>
<p>(2) ตัวอย่างประเภทของ "พฤติกรรมที่สังคมโดยทั่วไปไม่เป็นที่ยอมรับในสังคม" มีดังต่อไปนี้ นอกจากเนื้อหาที่อธิบายด้านล่างแล้ว ยังสามารถเพิ่มเติมพฤติกรรมที่ไม่เป็นที่ยอมรับอย่างเป็นกลางต่อสังคมได้อีกด้วย
</p>
<p>ดูหมิ่น / บิน / การกระทำสแลง
</p>
<p>พฤติกรรมทางกฎหมาย
</p>
<p>การกระทำอื่น ๆ ที่ละเมิดสิทธิ์ในเครื่องหมายการค้าหรือลิขสิทธิ์ของบุคคลที่สามหรือถือว่าละเมิด
</p>
<p>การแอบอ้างบุคคลอื่นหรือการฉ้อโกงที่เกี่ยวข้องกับบริการ เช่น ทีมปฏิบัติการ (GM), นักพัฒนา, NPC เป็นต้น
</p>
<p>ไม่ฝักใฝ่ฝ่ายใด
</p>
<p>ธุรกรรมเงินสดและธุรกรรมทางบัญชี
</p>
<p>การกระทำเพื่อวัตถุประสงค์ในการทำลายโดยเจตนา
</p>
<p>ถือว่าเกี่ยวข้องกับพฤติกรรมที่ผิดกฎหมาย
</p>
<p>พฤติกรรมที่ทำให้เสื่อมเสียศาสนา เชื้อชาติ ประเทศ หรือกลุ่มใดกลุ่มหนึ่ง
</p>
<p>พฤติกรรมอื่นๆ ที่อาจทำให้ผู้ใช้รู้สึกไม่สบายหรือไม่สบาย
</p>
<p>การใช้ Google Play Store, Yijia Store, Apple App Store ฯลฯ ในทางที่ผิดเพื่อยกเลิกนโยบายการตัดสินของตลาดและรับทรัพย์สินของเกมโดยเจตนา
</p>
<p>
</p>
<p>เก้า ใช้ข้อจำกัด
</p>
<p>* ระยะเวลาการลงโทษหมายถึงระยะเวลาการใช้งานที่จำกัดของเกม ยกเว้นเกม เกมอื่นที่ใช้แพลตฟอร์มแบบบูรณาการก็สามารถใช้ได้ อย่างไรก็ตาม หากถือว่าละเมิดกฎหมายที่เกี่ยวข้องหรือก่อให้เกิดผลกระทบร้ายแรงต่อ เกมแพลตฟอร์มจะถูก จำกัด บัญชีโปรดให้ความสนใจ
</p>
<p>(1) บริษัทสามารถใช้มาตรการคว่ำบาตรเกมที่สอดคล้องกับสมาชิกตามจำนวนการละเมิด "พฤติกรรมที่ไม่เหมาะสมและผิดปกติ" สะสม และบริษัทสามารถเพิ่มการลงโทษได้เมื่อมี "พฤติกรรมที่ไม่เหมาะสมและผิดปกติ" มากกว่าสองประเภทคือ ดำเนินการในมาตรฐานเดียวกัน
</p>
<p>(2) แม้ว่าจะไม่เป็นไปตามข้อกำหนดข้างต้น เมื่อกฎหมายและข้อบังคับที่เกี่ยวข้องถูกละเมิด หรืออยู่ภายใต้ดุลยพินิจของผู้ดำเนินการ ระยะเวลาและวิธีการจำกัดการใช้งานอาจเปลี่ยนแปลงได้ และเกมทั้งหมดที่บริษัทจัดหาให้ มีการเชื่อมต่อหรือมีข้อจำกัดเพิ่มเติม
</p>
<p>(3) เมื่อสมาชิกได้รับไอเทม สกุลเงินในเกม ฯลฯ ผ่าน "พฤติกรรมที่ไม่เป็นระเบียบและผิดปกติ" บริษัทสามารถรวบรวมได้
</p>
<p>(3) เมื่อความเสียหายเกิดขึ้นกับบริษัทเนื่องจาก "พฤติกรรมที่ไม่เป็นระเบียบและผิดปกติ" บริษัทอาจใช้มาตรการทางกฎหมายอื่นๆ เช่น การชดเชยให้กับสมาชิก
</p>
<p>(3) สมาชิกที่คัดค้านการคว่ำบาตรของบริษัทสามารถยื่นคำร้องคัดค้านผ่านศูนย์บริการลูกค้า PANGSKY
</p>
<p>
</p>
<p>X. นโยบายการคว่ำบาตร
</p>
<p>(1) เพื่อสร้างวัฒนธรรมการใช้งานที่ดี ทีมปฏิบัติการเคารพวัฒนธรรมการใช้เกมที่มีวินัยในตนเองของสมาชิก และจะไม่เข้าไปแทรกแซงโดยไม่จำเป็น อย่างไรก็ตาม จีเอ็มสามารถใช้มาตรการต่อไปนี้โดยไม่ต้องแจ้งให้ทราบล่วงหน้าเพื่อรักษาความสงบเรียบร้อยและไม่ปฏิบัติตามนโยบายการดำเนินงาน
</p>
<p>-ข้อจำกัดของบัญชี: ข้อ จำกัด การใช้บริการเกม
</p>
<p>-การจำกัดการแชท: การจำกัดการใช้บริการแชท
</p>
<p>-คำเตือน: ข้อจำกัดชั่วคราว เช่น คำแนะนำจากทีมปฏิบัติการ
</p>
<p>-รายการปรับปรุงและรีไซเคิล: ลบข้อมูลตัวละคร อุปกรณ์ประกอบฉาก เชื้อเพลิง ทรัพย์สิน ฯลฯ ที่เกี่ยวข้องกับการละเมิดข้อกำหนดหรือเปลี่ยนปริมาณและลักษณะ
</p>
<p>(2) เมื่อบริษัทกำหนดมาตรการคว่ำบาตร ก็สามารถเรียกคืนหรือปรับผลประโยชน์ (พร็อพ แต้มประสบการณ์ ฯลฯ) ที่เกี่ยวข้องกับการละเมิดเงื่อนไขได้ สำหรับการละเมิดเงื่อนไขที่ยากต่อการคำนวณผลประโยชน์ที่ผิดกฎหมาย โปรแกรมและประโยชน์อื่นๆ ที่เกี่ยวข้อง มันสามารถเริ่มต้นข้อมูลการใช้งานเกม
</p>
<p>(3) เหตุผลความรับผิดชอบของสมาชิกสำหรับการใช้บัญชีหรือการละเมิดการแบ่งปันบัญชีของข้อกำหนดและเงื่อนไขจะตกเป็นภาระของฝ่ายที่ละเมิดข้อกำหนดและสมาชิกของบัญชีดาราและการลงโทษอาจถูกนำไปใช้กับบัญชีของทั้งสองฝ่าย .
</p>
<p>(4) เมื่อมีการยืนยันการละเมิดข้อกำหนดตั้งแต่สองครั้งขึ้นไปพร้อมกัน บริษัทสามารถกำหนดบทลงโทษที่เกี่ยวข้องกับพฤติกรรมแต่ละอย่างได้
</p>
<p>(5) บริษัทสามารถประมวลผลการละเมิดข้อกำหนดโดยสมาชิกคนอื่น ๆ หรือช่วยสมาชิกที่สมรู้ร่วมคิดหรือละเมิดข้อกำหนดหรือสมาชิกที่ได้รับผลประโยชน์ที่ไม่ชอบด้วยกฎหมายให้ใช้บทลงโทษที่เกี่ยวข้องสำหรับการละเมิดข้อกำหนด .
</p>
<p>(6) บริษัทสามารถรีไซเคิลผลิตภัณฑ์ที่เกี่ยวข้องได้เมื่อได้รับผลิตภัณฑ์ที่ได้รับจากสมาชิกรายอื่นโดยละเมิดข้อกำหนดและเงื่อนไขโดยมีความรู้ในสถานการณ์ของตนหรือเสียค่าใช้จ่ายโดยปราศจากความรู้ในสถานการณ์ดังกล่าว
</p>

<p>(7) เกี่ยวกับการลงโทษและเนื้อหาของการลงโทษ โปรดปฏิบัติตามตารางมาตรฐานการคว่ำบาตรต่อไปนี้: อย่างไรก็ตาม แม้ว่าเหตุผลในการคว่ำบาตรที่ระบุไว้ในตารางมาตรฐานการคว่ำบาตรจะเกิดขึ้น คุณสามารถพิจารณาขอบเขตของผลกระทบของการละเมิด ของเงื่อนไขเฉพาะสถานการณ์หรือบริการในขณะนั้น ไม่มีการลงโทษหรืออ่อนแอกว่าตารางมาตรฐานการลงโทษ
</p>
<p>(8) แม้ในกรณีที่ไม่ได้ระบุไว้ในตารางมาตรฐานการคว่ำบาตรต่อไปนี้ บทลงโทษยังสามารถนำไปใช้กับการละเมิดข้อกำหนดและกฎหมายและข้อบังคับที่เกี่ยวข้องตามระดับความรุนแรง
</p>
<p>1. การหมิ่นประมาท คำพูดและการกระทำที่หยาบคาย การล่วงละเมิด คำพูดและการกระทำที่สะเทือนอารมณ์ และพฤติกรรมอื่น ๆ ที่ละเมิดความงามและประเพณี [1 ครั้ง: 1 วัน จำกัดการใช้ (แชท) / 2 ครั้ง: 7 วัน จำกัด การใช้ (แชท) / 3 ครั้ง: ข้อจำกัดการใช้งาน 30 วัน (แชท) / 4 ครั้ง: การจำกัดการใช้งานแบบถาวร (แชท)]
</p>
<p>2. การลงทะเบียนข้อมูลที่ไม่มีความหมาย ข้อมูลการโฆษณา ฯลฯ อย่างต่อเนื่องหรือเป็นระยะ ๆ ผ่านวิธีการสื่อสารข้อมูล เช่น แชทและกระดานข้อความ ทำให้สูญเสีย [ครั้งที่ 1: จำกัดการใช้ 1 วัน (แชท) / ครั้งที่ 2: ขีด จำกัด การใช้งาน 7 วัน (แชท) / ครั้งที่ 3: ขีด จำกัด การใช้งาน 30 วัน (แชท) / ครั้งที่ 4: ขีด จำกัด การใช้งานถาวร (แชท)]
</p>
<p>3. ก่อให้เกิดการละเมิด การหมิ่นประมาท ข้อพิพาท ฯลฯ กับบุคคลหรือกลุ่ม [ครั้งที่ 1: จำกัดการใช้งาน 1 วัน (แชท) / ครั้งที่ 2: การจำกัดการใช้งาน 7 วัน (แชท) / ครั้งที่ 3: 30 จำกัดการใช้งานรายวัน (แชท) )/4th: ขีด จำกัด การใช้งานถาวร (แชท)]
</p>
<p>4. จงใจขัดขวางสมาชิกคนอื่น ๆ จากการใช้บริการที่ราบรื่นหรือทำให้เกิดพฤติกรรมที่ไม่พึงประสงค์ [1 ครั้ง: ขีด จำกัด การใช้งาน 1 วัน (แชท) / 2 ครั้ง: ขีด จำกัด การใช้งาน 7 วัน (แชท) / 3 ครั้ง: ขีด จำกัด การใช้งาน 30 วัน (แชท) / 4 ครั้ง: ขีด จำกัด การใช้งานถาวร (แชท)]
</p>
<p>5. การใช้ชื่อเล่นหรือรูปภาพที่ละเมิดความงามและขนบธรรมเนียมประเพณี [ข้อจำกัดการใช้งานชั่วคราวถูกยกเลิกหลังจากการเปลี่ยนแปลง]
</p>
<p>6. การได้มาซึ่งเนื้อหาเกมโดยวิธีการที่ไม่เหมาะสม [ข้อจำกัดถาวร]
</p>
<p>7. การแอบอ้างเป็น "ผู้ดำเนินการ", "บริษัท" ที่เกี่ยวข้องกัน หรือพฤติกรรมมิตรภาพของผู้ที่เกี่ยวข้อง [ข้อจำกัดถาวร]
</p>
<p>8. พฤติกรรมการใช้ช่องโหว่ของระบบโดยจงใจและมักมุ่งร้าย [ครั้งแรก: ขีดจำกัดการใช้งาน 12 เดือน/ครั้งที่สอง: ขีดจำกัดการใช้งานถาวร]
</p>
<p>9. พฤติกรรมที่มีผลกระทบเล็กน้อยต่อเกมเมื่อไม่รู้จักบั๊ก [ครั้งแรก: จำกัดการใช้งาน 1 วัน / ครั้งที่ 2: จำกัดการใช้งาน 3 วัน / ครั้งที่ 3: จำกัด การใช้งาน 7 วัน / ครั้งที่ 4: 30- ขีด จำกัด การใช้วัน]
</p>
<p>10. ความล้มเหลวในการประกาศหรือช่วยเหลือหรือการแสวงหาผลประโยชน์ที่เป็นอันตรายหลังจากระบุจุดบกพร่อง [ครั้งที่ 1: ขีดจำกัดการใช้งาน 3 วัน/ ครั้งที่ 2: การจำกัดการใช้งาน 7 วัน/ ครั้งที่ 3: การจำกัดการใช้งาน 30 วัน/ ครั้งที่ 4: การจำกัดถาวร ในการใช้งาน]
</p>
<p>11. พฤติกรรมที่ส่งผลกระทบอย่างมากต่อเกมหลายครั้งหลังจากตรวจพบจุดบกพร่อง [การจำกัดการใช้งานถาวร]
</p>
<p>12. พฤติกรรมการแพร่กระจายจุดบกพร่องไปยังผู้ใช้รายอื่น [ครั้งแรก: ขีดจำกัดการใช้งาน 7 วัน/ ครั้งที่สอง: ขีดจำกัดการใช้งาน 30 วัน/ ครั้งที่สาม: การจำกัดการใช้งานแบบถาวร]
</p>
<p>13. พฤติกรรมการขายไอเทมในเกมและเงินในเกมในรูปของเงินสดหรือสิ่งของ เป็นต้น [ครั้งที่ 1: ขีดจำกัดการใช้ 3 วัน / ครั้งที่ 2: การจำกัดการใช้ 7 วัน / ครั้งที่ 3: 30 วัน ขีด จำกัด การใช้ / ครั้งที่ 4: ขีด จำกัด การใช้งานถาวร]
</p>
<p>14. พฤติกรรมของอุปกรณ์ประกอบฉากในเกม สกุลเงินของเกมที่แลกกับอุปกรณ์ประกอบฉากเกม [ครั้งที่ 1: การจำกัดการใช้ 3 วัน/ ครั้งที่ 2: การจำกัดการใช้ 7 วัน/ ครั้งที่ 3: การจำกัดการใช้ 30 วัน/ ครั้งที่ 4: การจำกัดการใช้อย่างถาวร ]
</p>
<p>15. การดำเนินการขายหรือแลกเปลี่ยนบัญชีและบทบาทที่ใช้ร่วมกัน เงินสดหรือสิ่งของอื่นๆ [ครั้งที่ 1: ขีดจำกัดการใช้ 3 วัน/ ครั้งที่ 2: ขีดจำกัดการใช้ 7 วัน/ ครั้งที่ 3: ขีดจำกัดการใช้ 30 วัน/ ครั้งที่ 4: ขีด จำกัด การใช้งานถาวร]
</p>
<p>16. การปลอมแปลง/ปลอมแปลงและเผยแพร่แอพพลิเคชั่นซอฟต์แวร์ [ข้อจำกัดการใช้งานถาวร]
</p>
<p>17. การเผยแพร่ใบสมัครผ่านวิธีการที่บริษัทไม่อนุมัติ [ข้อจำกัดการใช้งานถาวร]
</p>
<p>18. การคาดหวังให้ผู้ใช้รายอื่นได้รับผลประโยชน์ที่ไม่เหมาะสมในเกม [ครั้งที่ 1: การจำกัดการใช้ 1 วัน/ ครั้งที่ 2: การจำกัดการใช้ 7 วัน/ ครั้งที่ 3: การจำกัดการใช้ 30 วัน/ ครั้งที่ 4: การจำกัดการใช้อย่างถาวร]
</p>
<p>19. ความพยายามในพฤติกรรม "ฉ้อโกง" [ครั้งที่ 1: จำกัดการใช้งาน 1 วัน / ครั้งที่ 2: จำกัดการใช้งาน 7 วัน / ครั้งที่ 3: จำกัดการใช้งาน 30 วัน / ครั้งที่ 4: จำกัดการใช้งานถาวร]
</p>
<p>20. การเข้าสู่ระบบบัญชีของผู้อื่นโดยไม่ได้รับอนุญาต ทำให้เจ้าของที่แท้จริงสูญเสียไป [ข้อจำกัดการใช้งานถาวร]
</p>
<p>21. พยายามบุกรุกอุปกรณ์และบริการเกมของผู้อื่นหรือแจกจ่ายเนื้อหาที่เกี่ยวข้อง [การจำกัดการใช้งานอย่างถาวร (ใช้มาตรการพิจารณาคดีพร้อมกันตามเหตุการณ์)]
</p>
<p>22. การเปิดเผยหรือขอข้อมูลส่วนบุคคลของผู้อื่น [การจำกัดการใช้อย่างถาวร (ใช้มาตรการทางศาลตามกรณีด้วย)]
</p>
<p>23. พฤติกรรมไม่ขอรีไซเคิลไอเทมหลังการคืนเงินผ่านร้านค้าในตลาดเปิด [ข้อจำกัดการใช้งานถาวร]
</p>
<p>24. เผยแพร่การใช้ร้านค้าในตลาดเปิดและกระบวนการของบริษัทโดยมุ่งร้าย [ข้อจำกัดการใช้งานอย่างถาวร]
</p>
<p>25. สร้างพฤติกรรมเก็งกำไรในเกมและเผยแพร่พฤติกรรมเหล่านี้ [ครั้งที่ 1: จำกัดการใช้ 1 วัน/ ครั้งที่ 2: จำกัดการใช้งาน 7 วัน/ ครั้งที่ 3: จำกัดการใช้งาน 30 วัน/ ครั้งที่ 4: จำกัดการใช้งานถาวร]
</p>
<p>26. การเผยแพร่ข้อเท็จจริงเท็จและข้อมูลที่ไม่ได้แจ้ง [ครั้งที่ 1: การจำกัดการใช้ 1 วัน / ครั้งที่ 2: การจำกัดการใช้ 7 วัน / ครั้งที่ 3: การจำกัดการใช้ 30 วัน / ครั้งที่ 4: การจำกัดการใช้ถาวร]
</p>
<p>27. เกี่ยวกับเนื้อหาของโฆษณาเชิงพาณิชย์และการประชาสัมพันธ์ [ครั้งที่ 1: จำกัดการใช้งาน 1 วัน / ครั้งที่ 2: การ จำกัด การใช้งาน 7 วัน / ครั้งที่ 3: การ จำกัด การใช้งาน 30 วัน / ครั้งที่ 4: การ จำกัด การใช้งานถาวร]
</p>
<p>28. การใช้ ผลิต และขายโปรแกรมผิดกฎหมายที่เกี่ยวข้องกับเกม [การจำกัดการใช้งานถาวร]
</p>
<p>29. แฮกเกอร์บุกรุกเข้าไปในโปรแกรม "บริษัท" หรือเข้าสู่ระบบโดยไม่ได้รับอนุญาต [การจำกัดการใช้งานถาวร]
</p>
<p>30. การยักยอกวิธีการชำระเงินของบุคคลที่สาม (บัตรเครดิต โทรศัพท์มือถือ ฯลฯ) [ข้อจำกัดการใช้งานถาวร]
</p>
<p>31. การแลกเปลี่ยนหรือแลกเปลี่ยน "เนื้อหา" ในเกมด้วยเงินสด ฯลฯ [การจำกัดการใช้งานถาวร]
</p>
<p>32. เมื่อศาล หน่วยงานสอบสวน หรือหน่วยงานธุรการที่เกี่ยวข้องออกคำสั่งยึดบัญชีถาวรหรือคำขอ [การจำกัดการใช้งานชั่วคราว-การจำกัดจะถูกยกเลิกเมื่อการสอบสวนสิ้นสุดลงและปัญหาได้รับการแก้ไข]
</p>
<p>ข้อยกเว้นข้อจำกัดการใช้บริการ:
</p>
<p>1. ตามหลักการของข้อบังคับการใช้บริการ ช่วงข้อจำกัดการใช้บริการจริงสามารถปรับได้ตามความรุนแรงหรือการทำซ้ำของเหตุการณ์
</p>
<p>2. นอกเหนือจากรายการการใช้บริการที่กำหนดไว้ เมื่อพฤติกรรมที่ไม่เหมาะสมเกิดขึ้นในแนวคิดทางสังคมดั้งเดิม การใช้บริการของ "ผู้ใช้" อาจถูกจำกัด
</p>
<p>หากมีการคัดค้านการจำกัดการใช้บริการ สามารถยื่นคำร้องผ่านศูนย์บริการลูกค้าได้ แต่จะไม่มีการคัดค้านหากเกิน 3 เดือนนับจากวันที่จำกัดการใช้บริการ </p>
<p>
</p>
<p>สิบเอ็ด นโยบายบัญชีที่ไม่เข้าสู่ระบบระยะยาว
</p>
<p>(1) เพื่อปรับปรุงบริการและปกป้องข้อมูลสมาชิก บริษัทสามารถลบข้อมูลเกม เช่น ตัวละครในบัญชีที่ไม่ได้ใช้เกมภายในระยะเวลาที่กำหนด แต่บริษัทต้องแจ้งข้อเท็จจริงผ่านเกมและ ประกาศกระดานสนทนาอย่างเป็นทางการ 15 วันก่อนลบข้อมูลเกม
</p>
<p>
</p>
<p>เวลาทำการของศูนย์บริการลูกค้าและสำนักงานให้คำปรึกษา
</p>
<p>[ ปังสกี้]
</p>
<p>- เวลาทำการของศูนย์บริการลูกค้า: 09:00 ~ 18:30 น. ในวันธรรมดา
</p>
<p>- วันทำการ: วันจันทร์ ถึง วันศุกร์ (ยกเว้นวันเสาร์ วันอาทิตย์ และวันหยุดนักขัตฤกษ์)
</p>
<p>- ที่อยู่สอบถาม: twfindercs@panggame.com
</p>
<p>
</p>
<p>※โดยหลักการแล้ว ความคิดเห็นที่ศูนย์ลูกค้าเสนอผ่านการให้คำปรึกษา คำแนะนำ และคำขอควรได้รับการดำเนินการภายใน 24 ชั่วโมง แต่การตอบสนองหรือการดำเนินการอาจล่าช้าเนื่องจากภาระทางธุรกิจและเหตุผลอื่นๆ
</p>
<p>
</p>
<p>ข้อบังคับ
</p>
<p>วันประกาศ : 16 พฤศจิกายน 2563
</p>
<p>มีผลใช้บังคับ: 16 พฤศจิกายน 2020</p>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: 'Terms',
    data () {
        return {
        };
    },
    watch: {
    },
    mounted () {
    },
}
</script>

<style scoped>

.faq-container {
    max-width: 1040px;
    width: 90vw;
    margin: 0 auto;
}

.Policy {
font-size: 14px;
color: #000;
line-height: 18px;
margin-bottom: 100px;
}

h1 {
    text-align: center;
}

</style>
